import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center m-5 flex-grow" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}

import { useRoute, useRouter } from "vue-router";
import Auth from "@/modules/Auth/Auth";
import Footer from './Footer.vue'
import { inject, onMounted, ref } from "vue";
import { User } from "firebase/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFAU',
  emits: ['is-page-loaded'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const route = useRoute();
const auth = inject("auth") as Auth;

function switchAccount() {
    auth.SignOut().then(() => {
        router.push({
            path: "/login",
            query: route.query,
        });
    });
}

const user = ref<User|null>();  
const emit = __emit;
emit('is-page-loaded', false);

onMounted(() => {

    auth.GetCurrentUser().then((u : User | null) => {
        //console.log(u);
        user.value = u;
    }).finally(() => {
        emit('is-page-loaded', true);
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-4xl mb-4 text-center text-fau-blue-bright font-light" }, "Incorrect Account", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-4" }, " You have signed in with a non-FAU account. Please sign in with your FAU account. ", -1)),
      (user.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode(" You are currently signed in as ", -1)),
            _createElementVNode("strong", null, _toDisplayString(user.value?.email), 1),
            _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: switchAccount,
        class: "bg-fau-blue-bright text-fau-white text-xl px-7 py-3"
      }, " Switch Accounts "),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-4" }, [
        _createTextVNode(" If you continue to experience issues, please contact "),
        _createElementVNode("a", {
          href: "mailto:idesign@fau.edu?subject=Login%20Issue%20-%20Non-FAU%20Account",
          style: {"color":"revert"}
        }, "idesign@fau.edu"),
        _createTextVNode(". ")
      ], -1))
    ]),
    _createVNode(Footer)
  ]))
}
}

})